module.exports = __webpack_public_path__ + "media/icons/plus-badf5233.svg";